var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FormFieldPrivate } from '../form-field-private';
import { FormFieldHeaderPrivate } from '../form-field-header-private';
import { FormFieldLabelPrivate } from '../form-field-label-private';
import { FormFieldRequiredIndicatorPrivate } from '../form-field-required-indicator-private';
import { FormFieldBodyPrivate } from '../form-field-body-private';
import { randomId } from '../lib-randomId';
import { DEFAULT_REQUIRED_FIELD_I18N } from '../forms-lib';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
export var DEFAULT_CHECKBOX_GROUP_I18N = {
    required: DEFAULT_REQUIRED_FIELD_I18N,
};
var CheckboxGroupField = /** @class */ (function (_super) {
    __extends(CheckboxGroupField, _super);
    function CheckboxGroupField(props) {
        var _this = _super.call(this, props) || this;
        _this.writeState = componentApi.writeState.bind(_this);
        _this.state = {};
        _this.state['labelId'] = '';
        return _this;
    }
    CheckboxGroupField.prototype.render = function () {
        return (React.createElement(FormFieldPrivate, { size: this.props.size, isGroup: true, alignment: this.getAlignment(), srLabelledBy: !this.props.label ? undefined : this.state.labelId },
            this.props.label ? (React.createElement(FormFieldHeaderPrivate, null,
                React.createElement(FormFieldLabelPrivate, { isHidden: this.props.isLabelHidden, identifier: this.state.labelId },
                    this.props.label,
                    ' ',
                    this.props.indicator === 'required' ? (React.createElement(FormFieldRequiredIndicatorPrivate, { i18n: this.getI18n().required }, this.getI18n().required.label)) : null))) : null,
            React.createElement(FormFieldBodyPrivate, null, this.props.children)));
    };
    CheckboxGroupField.prototype.getI18n = function () {
        return __assign(__assign({}, DEFAULT_CHECKBOX_GROUP_I18N), this.props.i18n);
    };
    CheckboxGroupField.prototype.getAlignment = function () {
        return this.props.groupAlignment || this.props.alignment;
    };
    CheckboxGroupField.prototype.componentDidMount = function () {
        this.writeState('labelId', randomId());
    };
    CheckboxGroupField.defaultProps = {
        size: 'large',
        alignment: 'vertical',
        indicator: 'none',
        i18n: DEFAULT_CHECKBOX_GROUP_I18N,
        isLabelHidden: false,
    };
    CheckboxGroupField.displayName = 'CheckboxGroupField';
    return CheckboxGroupField;
}(React.Component));
export { CheckboxGroupField };
